import React from "react"
import Fade from "react-reveal/Fade"
import Link from "../utils/link"
import { Arrow, Download, Marker } from "./icons"
import MachineGallery from "./machine-gallery"
import { navigate } from "gatsby"

const InStockMachine = ({
  title,
  blurb,
  bulletPoints,
  machineGallery,
  label,
  location,
  shippingText,
  brochure,
  darkMode,
  videoFile,
  youtubeLink
}) => {
  const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const niceBytes = (x) => {
    let l = 0,
      n = parseInt(x, 10) || 0

    while (n >= 1024 && ++l) {
      n = n / 1024
    }

    return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l]
  }
  
  const handleEnquiry = () => {
    const activeCampagin = document.querySelector(".active-campaign-component")

    if (activeCampagin) {
      //Once we determine what field to target we can insert the name of the machine
      // const input = document.getElementById('field[112]');
      // input.value = title;
      const top = activeCampagin.getBoundingClientRect().top
      window.scrollTo({
        top: top + window.scrollY - 80,
        behavior: "smooth",
      })
    } else {
      navigate("/contact")
    }
  }

  return (
    <section className={`in-stock-machine ${darkMode ? "dark" : ""}`}>
        <div className="in-stock-machine__inner">
          <div className="was a fade element">
            <div className="in-stock-machine-card">
              <div className="in-stock-machine-card__image">
                <MachineGallery
                  gallery={machineGallery}
                  videoFile={videoFile}
                  youtubeLink={youtubeLink}
                  label={label}
                  darkMode={darkMode}
                />
              </div>

              <div className="in-stock-machine-card__content">
                <h3>{title}</h3>
                <div className="in-stock-machine-card__excerpt">{blurb}</div>
                <ul className="in-stock-machine-card__bullets">
                  {bulletPoints?.map((el, i) => (
                    <li key={i}>
                      <h5>
                        <span className="square" />
                        <span>
                          {el.bulletPointText}
                        </span>
                      </h5>
                    </li>
                  ))}
                </ul>
                <div className="in-stock-machine-card__metadata">
                  {brochure?.map((el, i) => (
                    <a
                      key={i}
                      className="meta-row"
                      href={el?.acf.file?.localFile?.publicURL}
                      download
                    >
                      <div className="meta-row__header">
                        <Download />
                        <span className="meta-row__title">
                          Machine Brochure
                        </span>
                      </div>
                      <span className="meta-row__subtext">
                        {niceBytes(el.acf.file?.localFile?.size)}
                      </span>
                    </a>
                  ))}
                  <div className="meta-row">
                    <div className="meta-row__header">
                      <Marker />
                      <span className="meta-row__title">{location}</span>
                    </div>
                    <span className="meta-row__subtext">{shippingText}</span>
                  </div>
                </div>
                <button onClick={handleEnquiry} className="btn btn--arrow">
                  <span>Enquire Now</span>
                  <Arrow />
                </button>
              </div>
            </div>
          </div>
        </div>
    </section>
  )
}

export default InStockMachine
